import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  Collapse,
  Avatar,
  IconButton,
  Typography,
} from "@mui/material";
import { red } from "@mui/material/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ListSubheader from "@mui/material/ListSubheader";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import { HashLink as Link } from "react-router-hash-link";
import "swiper/css";
import "swiper/css/pagination";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Box from "@mui/material/Box";
import "../styles/Aerospace.css";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";

const cardsData = [
  {
    id: 1,
    url: " https://www.visitutah.com/things-to-do/river-rafting",
    title: "Rafting",
    subtitle: "Locations",
    image: "/img/upantf0ryf2tcvfsbgxk.webp",
    shortDescription: "Colorado River (Moab, Fisher Towers, Grand Canyon ...",
    fullDescription:
      "Colorado River (Moab, Fisher Towers, Grand Canyon Expeditions), Green River, Provo River, Jordanelle.",
  },
  {
    id: 2,
    url: " https://www.visitutah.com/things-to-do/hiking",
    title: "Hiking",
    subtitle: "Locations",
    image: "/img/f7cwja2nvk6ocs2ifpy3.webp",
    shortDescription: "Zion National Park (The Narrows, Angels Landing)...",
    fullDescription:
      "Zion National Park (The Narrows, Angels Landing), Bryce Canyon National Park, Arches National Park, Canyonlands National Park, Capitol Reef National Park, Grand Staircase-Escalante National Monument,1 Cedar Breaks National Monument, Ensign Peak (Salt Lake City), City Creek Canyon, Millcreek Canyon, Big Cottonwood Canyon, Little Cottonwood Canyon, Corner Canyons, Utah Valley (Mount Timpanogos, Mount Nebo, Provo Canyon), Wasatch Range, Antelope Island State Park, Goblin Valley State Park, San Rafael Swell, Red Butte Garden, Dinosaur National Monument.",
  },

  {
    id: 3,
    url: " https://www.visitutah.com/things-to-do/camping",
    title: "Camping",
    subtitle: "Locations",
    image: "/img/CA_Hero-Camping2 (1) (1).webp",
    shortDescription:
      "Glen Canyon and Lake Powell, Grand Staircase-Escalante...",
    fullDescription:
      "Glen Canyon and Lake Powell, Grand Staircase-Escalante National Monument, Moab, San Rafael Swell, St. George, Arches National Park, Bryce Canyon, Canyon Lands, Capitol Reef, Zion National Park, Antelope Island, Bear Lake, Big Cottonwood Canyon, Dinosaur National Monument, Flaming George, Little Cottonwood Canyon, Uinta Mountain",
  },
  {
    id: 4,
    url: " https://www.visitutah.com/things-to-do/climbing-bouldering",
    title: "Rock Climbing",
    subtitle: "Locations",
    image: "/img/rock-climbing.webp",
    shortDescription: "Various locations across Utah, including Moab.",
    fullDescription: "Various locations across Utah, including Moab.",
  },
  {
    id: 5,
    url: "https://www.visitutah.com/things-to-do/backpacking ",
    title: "Backpacking",
    subtitle: "Locations",
    image: "/img/Needles-backpacking-Chesler-ASloss (1).webp",
    shortDescription:
      "Zion National Park (The Narrows, Angels Landing), Bryce Canyon National Park...",
    fullDescription:
      "Zion National Park (The Narrows, Angels Landing), Bryce Canyon National Park, Arches National Park, Canyonlands National Park, Capitol Reef National Park, Grand Staircase-Escalante National Monument,1 Cedar Breaks National Monument, Ensign Peak (Salt Lake City), City Creek Canyon, Millcreek Canyon, Big Cottonwood Canyon, Little Cottonwood Canyon, Corner Canyons, Utah Valley (Mount Timpanogos, Mount Nebo, Provo Canyon), Wasatch Range, Antelope Island State Park, Goblin Valley State Park, San Rafael Swell, Red Butte Garden, Dinosaur National Monument.",
  },
  {
    id: 6,
    url: " https://www.visitutah.com/things-to-do/stargazing",
    title: "Stargazing",
    subtitle: "Locations",
    image: "/img/wnbyg7lkpeef1kl3wfpo.webp",
    shortDescription:
      "Utahs state parks, national parks, and national monuments (many are certified Dark...",
    fullDescription:
      "Utahs state parks, national parks, and national monuments (many are certified Dark Sky Parks, including Capitol Reef National Park, Kodachrome Basin State Park, Bryce Canyon National Park, Cedar Breaks National Monument).",
  },
  {
    id: 7,
    url: " https://www.visitutah.com/things-to-do/road-cycling",
    title: "Cycling",
    subtitle: "Locations",
    image: "/img/23442838434_24b9e876ac_k (1).webp",
    shortDescription:
      "Golden Spike, Antelop Island State Park, Bear Lake, Logan Canyon, Cottonwood Canyons... ",
    fullDescription:
      "Golden Spike, Antelop Island State Park, Bear Lake, Logan Canyon, Cottonwood Canyons, Alpine Loop, Parowan Gap Loop, Sevier Highway, Upper Colorado Scenic Byway,  West Mountain Loop ",
  },
  {
    id: 8,
    url: "https://www.visitutah.com/things-to-do/fishing ",
    title: "Fishing",
    subtitle: "Locations",
    image: "/img/fish-in-hand-blog (1).webp",
    shortDescription:
      "Bear Lake, Currant Creek, Duchesne River, Flaming Gorge, Grren River,Jordanelle...",
    fullDescription:
      "Bear Lake, Currant Creek, Duchesne River, Flaming Gorge, Grren River, Jordanelle State Park, Canyon Lake, Logan River, Lost Creek State Park, Ogden River, Pellican Lake, Pineview Reservoir, Provo River, Scofield State Park, Starvation State Park, Strawberry Reservoir, Uinta Mountain Lakes, Weber River",
  },
  {
    id: 9,
    url: " https://www.visitutah.com/things-to-do/mountain-biking",
    title: "Mountain Biking",
    subtitle: "Locations",
    image: "/img/bl67lloctlpbqlrgj61o.webp",
    shortDescription:
      "Moab (Slickrock Trail, Gooseberry Mesa, Thunder Mountain), Park City...",
    fullDescription:
      "Moab (Slickrock Trail, Gooseberry Mesa, Thunder Mountain), Park City, Utah Valley, City Creek Canyon, Millcreek Canyon, Big Cottonwood Canyon, Little Cottonwood Canyon, Corner Canyons.",
  },
  {
    id: 10,
    url: " https://www.visitutah.com/things-to-do/hot-air-balloons",
    title: "Hot Air Balloning",
    subtitle: "Locations",
    image: "/img/28315869142_24f04ebfab_k (1).webp",
    shortDescription:
      "Various locations across Utah, often associated with festivals.",
    fullDescription:
      "Various locations across Utah, often associated with festivals.",
  },
  {
    id: 11,
    url: " https://www.visitutah.com/things-to-do/slot-canyons",
    title: "Canyoneering",
    subtitle: "Locations",
    image: "/img/janiathuekp9gdjlw0vy.webp",
    shortDescription:
      "Zion National Park (The Narrows), Moab, Orderville (e.g., Coral Sands)...",
    fullDescription:
      "Zion National Park (The Narrows), Moab, Orderville (e.g., Coral Sands), Mt. Carmel (Stone Hollow Canyon).",
  },
  {
    id: 12,
    url: " https://www.visitutah.com/things-to-do/nature-wildlife",
    title: "Nature and WildLife",
    subtitle: "Locations",
    image: "/img/15516804349_6cf3ed483c_k (1).webp",
    shortDescription:
      "Hub of National Parks and Forests, State Parks, Wildlife Refuges",
    fullDescription:
      "National Parks and Forests, State Parks, Wildlife Refuges",
  },
  {
    id: 13,
    url: "https://www.visitutah.com/things-to-do/motorized-off-road ",
    title: "OHV And Off-Road",
    subtitle: "Locations",
    image: "/img/28720996713_aec69a0508_k (1).webp",
    shortDescription: "Moab (Hummer Tours, Jeep Rentals...",
    fullDescription:
      "Moab (Hummer Tours, Jeep Rentals, Hells Revenge UTV Tour), Monument Valley Navajo Tribal Park, Hurricane (Sand Hollow State Park, ATV Desert Adventure), Vernal (Red Mountain OHV Trail, Outlaw Trail system), Kanab, Orderville (Zion Sunset Jeep Tour).",
  },
  {
    id: 14,
    url: " https://www.utah.com/things-to-do/outdoor-recreation/sky-diving/",
    title: "Sky Diving",
    subtitle: "Locations",
    image: "/img/pcfhgt9yzjxj4n7rzwvs.webp",
    shortDescription: "Situated in various locations across Utah.",
    fullDescription: "Various locations across Utah.",
  },
  {
    id: 15,
    url: " http://www.ziplineutah.com/?gad_source=1&gad_campaignid=21847908681&gbraid=0AAAAA-Tm-8bt6aWz2d3OYD_abLmUpQ5JB&gclid=Cj0KCQjwlrvBBhDnARIsAHEQgORcUMoJagZAHS3SguresRD3KnecVHxU7bQnsjsYxi-OWjYi5OMV5RwaAoBmEALw_wcB",
    title: "Ziplining",
    subtitle: "Locations",
    image: "/img/sibufsswcvnoak2wynpj.webp",
    shortDescription: "Moab, Herber City (Ultimate Zipline...",
    fullDescription:
      "Moab, Herber City (Ultimate Zipline Adventure Tour), Big Rock Adventure.",
  },
  {
    id: 16,
    url: " https://www.visitutah.com/things-to-do/horseback-riding",
    title: "Horse Back Riding",
    subtitle: "Locations",
    image: "/img/horse-back-riding.webp",
    shortDescription: "Midway (Soldier Hollow), Kanab...",
    fullDescription:
      "Midway (Soldier Hollow), Kanab, Monument Valley, Bryce Canyon City, Orderville.",
  },
];

const itemData = [
  {
    id: 17,
    url: " https://www.visitutah.com/things-to-do/skiing",
    img: "/img/Ski_Famille_-_Family_Ski_Holidays.webp",
    title: "Skiing",
    shortDescription: "Park City Mountain, Snowbird Resort, Alta Ski...",
    author:
      "Park City Mountain, Snowbird Resort, Alta Ski Area, Deer Valley Resort, Sundance Mountain Resort, Woodward Park City, Solitude Mountain Resort.",
    rows: 4,
    cols: 2,
    featured: true,
  },

  {
    id: 18,
    url: " https://www.visitutah.com/things-to-do/snowmobiling",
    img: "/img/35799889754_59aea5840a_k.webp",
    title: "Snowmobiling",
    author: "Over 800 miles of groomed trails throughout Utah.",
    shortDescription: "Over 800 miles of groomed trails throughout Utah.",
  },
  {
    id: 19,
    url: "https://www.visitutah.com/things-to-do/snowshoeing ",
    img: "/img/snowshoeing.webp",
    title: "Snowshoeing",
    author: "Various locations with powdery snow.",
    shortDescription: "Various locations with powdery snow.",
    cols: 2,
  },
  {
    id: 20,
    url: "https://www.visitutah.com/things-to-do/snowboarding ",
    img: "/img/snow-boarding.webp",
    title: "Snowboarding",
    shortDescription: "Park City Mountain, Snowbird Resort, Alta Ski...",
    author:
      "Park City Mountain, Snowbird Resort, Alta Ski Area, Deer Valley Resort, Sundance Mountain Resort, Woodward Park City, Solitude Mountain Resort.",
  },

  {
    id: 21,
    url: "https://www.visitutah.com/things-to-do/cross-country-skiing ",
    img: "/img/cross-skiing.webp",
    title: "Cross Country Skiing",
    author: "Northern, Central, and Southern Utah (popular Nordic trailheads).",
    shortDescription: "Northern, Central, and Southern Utah...",
    cols: 2,
  },
  {
    id: 22,
    url: " https://www.visitutah.com/things-to-do/ice-fishing",
    img: "/img/icefishing.webp",
    title: "Ice Fishing",
    author:
      "Bear Lake, Fish Lake, Flaming Gorge, Scofield State Park, Strawberry Reservoir. ",
    shortDescription: "Bear Lake, Fish Lake, Flaming...",
  },
  {
    id: 23,
    url: "https://www.visitutah.com/things-to-do/hiking/winter-hiking ",
    img: "/img/29409462580_cbf621d87a_k.webp",
    title: "Winter Hiking",
    author:
      "Zion National Park (The Narrows), Bryce Canyon National Park (Rim Trail), Moab(Corona Arch Trail), American Fork (Pine Hollow Trail), Salt Lake City (Silver Lake Loop)",
    rows: 2,
    cols: 2,
    featured: true,
    shortDescription: "Zion National Park (The Narrows), Bryce...",
  },
  {
    id: 24,
    url: " https://www.visitutah.com/things-to-do/ice-skating",
    img: "/img/250px-Langfardsskridskoakning.webp",
    title: "Ice Skating",
    shortDescription: "Salt Lake City (Gallivan Center, Steiner...",
    author:
      "Salt Lake City (Gallivan Center, Steiner/SLC Sports Complex), Park City (Park City Ice Arena, Resort Center), Acord Ice Center, Bountiful Ice ribbon, Cottonwood Heights Ice Arena, George S.Eccless Ice Center, Ice Ribbon at J.Lynn Crane Plaza, Midway Ice, Millcreek Common Skate Loop,  Salt Lake County Ice Center, Utah Olympic Oval.",
  },
  {
    id: 25,
    url: " https://www.visitutah.com/things-to-do/snow-tubing-sledding",
    img: "/img/snow-tubing.webp",
    title: "Snow Tubing",
    shortDescription: "Cherry Peak Resort, Wasatch Parc...",
    author:
      "Cherry Peak Resort, Wasatch Parc snow tubing, Woodward Park City, Soldier Hollow, Buckskin Hills Recreation Complex, Brian Head Resort. ",
  },
  {
    id: 26,
    url: " https://www.visitutah.com/things-to-do/snow-tubing-sledding",
    img: "/img/sleeding.webp",
    title: "Snow Sledding",
    shortDescription: "Salt Lake City (Eaglewood Golf Course,...",
    author:
      "Salt Lake City (Eaglewood Golf Course, Popperton Park, Sugar House Park, Flat Iron Mesa Park, Rock Canyon Park), Bountiful (Mueller Park), Cotton Heights (Mountainview Park), Holladay( Creekside Park), Murray (Murray Park), Sandy (Eastridge Park, Willow Creek Park), Taylorsville (Bennion Park) and West Valley City (Hunter Park) ",
    rows: 2,
    cols: 2,
  },
];

export default function Adventure() {
  const [expandedCardId, setExpandedCardId] = useState(null);
  const [navbarBackground, setNavbarBackground] = useState("transparent");
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandSize, setExpandSize] = useState("lg");

  const handleExpandClick = (id) => {
    setExpandedCardId((prevId) => (prevId === id ? null : id));
  };

  const navigate = useNavigate();
  const [modalShow, setModalShow] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const checkLoginStatus = () => {
      const rawUser = localStorage.getItem("user");
      try {
        const storedUser = JSON.parse(rawUser);
        if (storedUser && storedUser.name) {
          setIsLoggedIn(true);
          setUserName(storedUser.name);
        } else {
          setIsLoggedIn(false);
          setUserName("");
        }
      } catch (error) {
        // Handle plain string (like "Vasquez") gracefully
        if (typeof rawUser === "string" && rawUser.trim()) {
          setIsLoggedIn(true);
          setUserName(rawUser);
        } else {
          setIsLoggedIn(false);
          setUserName("");
        }
      }
    };

    checkLoginStatus();

    window.addEventListener("storage", checkLoginStatus);

    return () => {
      window.removeEventListener("storage", checkLoginStatus);
    };
  }, []);

  const location = useLocation();
  const navbarRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1700) {
        setExpandSize(false);
      } else {
        setExpandSize("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setNavbarBackground(
        window.scrollY > 50 ? "rgb(30, 89, 190)" : "transparent"
      );
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsExpanded(false);
  }, [location]);

  return (
      <div>
        {/* <LandingSection data="https://vimeo.com/1092718789?share=copy#t=0" /> */}
        <LandingSection
        data={{
          imageName: "activities.png",
          title: "Adventure Activities", 
          visible: ""
        }}
      />
        <div className="verticals_section">
          <div className="verticals-intro">
            <div className="verticals-intro-sec1">
              <h2>Utah’s Adventure Sports</h2>
            </div>
            <div className="verticals-intro-sec2">
              <p>
                Utah offers thrilling adventure sports like rock climbing,
                mountain biking, rafting, and skiing, set against its stunning
                natural landscapes.
              </p>
              <Link to={"/about"}>
                {/* <ActionButton data="Know More About Us" /> */}
              </Link>
            </div>
          </div>
        </div>

        {/* Titles */}
        <h1 className="text-3xl font-bold text-center mt-10 mb-4">
          Utah Adventure Activities
        </h1>
        <h2 className="text-xl text-center font-semibold mb-6">
          Summer Activities
        </h2>

        {/* Cards Grid */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-stretch">
            {cardsData.map((card) => (
              <div key={card.id} className="flex flex-col">
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    borderRadius: 3,
                    boxShadow: 3,
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 6,
                      transform: "translateY(-4px)",
                    },
                  }}
                  className="adventure-card"
                >
                  <CardHeader
                    className="adventure-card-header"
                    avatar={
                      <Avatar
                        sx={{ bgcolor: red[500] }}
                        aria-label={card.title[0]}
                      >
                        {card.title[0]}
                      </Avatar>
                    }
                    title={card.title}
                    subheader={card.subtitle}
                  />
                  <CardMedia
                    component="img"
                    image={card.image}
                    alt={card.title}
                    className="adventure-card-media"
                  />
                  <CardContent className="adventure-card-content">
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      {card.shortDescription}
                    </Typography>
                  </CardContent>
                  <CardActions disableSpacing>
                    <IconButton aria-label="Visit official site">
                      <div className="flex flex-row">
                        {" "}
                        <a
                          href={card.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="no-underline flex flex-row"
                        >
                          <InfoIcon />
                          <div className="text-sm">Visit official site</div>
                        </a>
                      </div>
                    </IconButton>
                    <IconButton
                      onClick={() => handleExpandClick(card.id)}
                      aria-expanded={expandedCardId === card.id}
                      aria-label="show more"
                      sx={{ marginLeft: "auto" }}
                    >
                      <ExpandMoreIcon
                        className={`expand-icon ${
                          expandedCardId === card.id ? "expanded" : ""
                        }`}
                      />
                    </IconButton>
                  </CardActions>
                  <Collapse
                    in={expandedCardId === card.id}
                    timeout="auto"
                    unmountOnExit
                  >
                    <CardContent>
                      <Typography paragraph>{card.fullDescription}</Typography>
                    </CardContent>
                  </Collapse>
                </Card>
              </div>
            ))}
          </div>

          <h2 className="text-xl font-semibold text-center m-6 mt-[5rem]">
            Winter Activities
          </h2>
          {/* <div className="flex justify-center">
            <ImageList sx={{ width: 1300, height: 650 }}>
              <ImageListItem key="Subheader" cols={2}>
                <ListSubheader component="div">Winter Activities</ListSubheader>
              </ImageListItem>
              {itemData.map((item) => (
                <ImageListItem key={item.img}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item.img}?w=248&fit=crop&auto=format`}
                      alt={item.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </a>

                  <Box
                    sx={{
                      px: 1,
                      py: 1,
                      backgroundColor: "#f8f8f8",
                      borderRadius: "0 0 8px 8px",
                      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        whiteSpace: "pre-wrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 12,
                        WebkitBoxOrient: "vertical",
                        color: "text.secondary",
                        mt: 0.5,
                      }}
                    >
                      {item.author}
                    </Typography>
                  </Box>
                </ImageListItem>
              ))}
            </ImageList>
          </div> */}

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-stretch">
            {itemData.map((item) => (
              <div className="flex flex-col">
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    borderRadius: 3,
                    boxShadow: 3,
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 6,
                      transform: "translateY(-4px)",
                    },
                  }}
                  className="adventure-card"
                >
                  <CardHeader
                    className="adventure-card-header"
                    avatar={
                      <Avatar
                        sx={{ bgcolor: red[500] }}
                        aria-label={item.title[0]}
                      >
                        {item.title[0]}
                      </Avatar>
                    }
                    title={item.title}
                    // subheader={item.author}
                  />
                  <CardMedia
                    component="img"
                    image={item.img}
                    alt={item.title}
                    className="adventure-card-media"
                  />
                  <CardContent className="adventure-card-content">
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      {item.shortDescription}
                    </Typography>
                  </CardContent>
                  <CardActions disableSpacing>
                    <IconButton
                      onClick={() => handleExpandClick(item.id)}
                      aria-expanded={expandedCardId === item.id}
                      aria-label="show more"
                      sx={{ marginLeft: "auto" }}
                    >
                      <ExpandMoreIcon
                        className={`expand-icon ${
                          expandedCardId === item.id ? "expanded" : ""
                        }`}
                      />
                    </IconButton>
                  </CardActions>
                  <Collapse
                    in={expandedCardId === item.id}
                    timeout="auto"
                    unmountOnExit
                  >
                    <CardContent>
                      <Typography paragraph>{item.author}</Typography>
                    </CardContent>
                  </Collapse>
                </Card>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-16 border-t border-gray-300 pt-6 text-center text-sm text-gray-700 max-w-3xl mx-auto px-4">
          <p>
            <strong>Disclaimer:</strong> UTahData.org is an independent platform
            that compiles publicly available information about adventure
            activities in Utah. We do not own or claim any rights to the images,
            names, or content related to the listed destinations or
            organizations. All information is provided for general informational
            purposes only. Please consult the official websites or contact the
            respective providers for the most accurate, up-to-date, and
            safety-related information before planning your activities.
          </p>
        </div>

        {/* Data Sources */}
        <div className="mt-8 border-t border-gray-300 pt-6 text-center text-sm text-gray-700 max-w-3xl mx-auto px-4">
          <p className="font-semibold mb-3">Data Sources:</p>
          <div className="flex flex-col items-center gap-2">
            <a
              target="_blank"
              href="https://www.visitutah.com/things-to-do"
              rel="noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800 underline"
            >
              Visit Utah - Things to Do
            </a>
            <a
              target="_blank"
              href="https://www.utah.com/things-to-do"
              rel="noreferrer"
              className="text-sm text-blue-600 hover:text-blue-800 underline"
            >
              Utah.com - Things to Do
            </a>
          </div>
        </div>
      

      <Footer />
      </div>
  );
}
